import { Server } from 'lucide-react'

import { Badge } from '../../ui/Badge'
import { hostDisplayName } from '../../core/hostName'
import type { CatalogHostDto } from '../../data/types'

export type SizeContextState = 'loading' | 'ready' | 'unavailable' | 'unreported'

function hostName(host: CatalogHostDto): string {
  return hostDisplayName(host)
}

/**
 * Which host a host-bound size is measured against.
 *
 * Context, not an alert: in the normal case it is a compact row for the card
 * header. Only a real problem — nothing free, or nothing reported — keeps the
 * caution notice, so the warning colour still means something.
 */
export function SizeContext({ host, state }: { host: CatalogHostDto; state: SizeContextState }) {
  if (state === 'unavailable' || state === 'unreported') {
    return <div className="notice notice-caution" role="status">
      <strong>{state === 'unavailable' ? 'This host has no free capacity right now' : 'Selected host capacity is not reported'}</strong>
      <p>{hostName(host)} · {host.region} · {host.tier}</p>
    </div>
  }
  return <div className="size-context">
    <Server aria-hidden="true" size={16} />
    <span className="size-context-host">{hostName(host)}</span>
    <span className="size-context-region">{host.region}</span>
    <Badge tone="neutral" mark={false}>Tier {host.tier}</Badge>
    {state === 'loading' && <span className="muted" role="status">Checking capacity…</span>}
  </div>
}
